import { lazy } from "react";
import ErrorPage from "../../components/UI/ErrorPage";
import AdminRoute from "../RouteGuards/AdminRouteGuard"; // ✅ protect admin
import {
  viewProfileLoader,
  updateProfileLoader,
} from "../user/profile/profileLoaders";

// Lazy imports

const Home = lazy(() => import("../../pages/Admin/Home"));

const Users = lazy(() => import("../../pages/Admin/Users/Users"));
const ViewUser = lazy(() => import("../../pages/Admin/Users/ViewUser"));

const Assets = lazy(() => import("../../pages/Admin/assets/AllAssets"));
const ViewAsset = lazy(() => import("../../pages/Admin/assets/ViewAsset"));

const Orders = lazy(() => import("../../pages/Admin/orders/Orders"));
const ViewOrder = lazy(() => import("../../pages/Admin/orders/ViewOrder"));

const Transactions = lazy(
  () => import("../../pages/Admin/transactions/AllTransactions"),
);

const AllPosts = lazy(() => import("../../pages/Admin/blog/Blog"));
const NewPost = lazy(() => import("../../pages/Admin/blog/CreatePost"));
const UpdatePost = lazy(() => import("../../pages/Admin/blog/EditPost"));
const ViewPost = lazy(() => import("../../pages/Admin/blog/ViewPost"));
const Wallet = lazy(() => import("../../pages/Admin/wallet/Wallet"));

const AllPlatform = lazy(() => import("../../pages/Admin/platform/Platform"));
const NewPlatform = lazy(
  () => import("../../pages/Admin/platform/CreatePlatform"),
);
const UpdatePlatform = lazy(
  () => import("../../pages/Admin/platform/UpdatePlatform"),
);

const AllCategories = lazy(() => import("../../pages/Admin/category/Category"));
const NewCategory = lazy(
  () => import("../../pages/Admin/category/CreateCategory"),
);
const UpdateCategory = lazy(
  () => import("../../pages/Admin/category/UpdateCategory"),
);

const Profile = lazy(() => import("../../pages/User/Profile/Profile"));
const UpdateProfile = lazy(
  () => import("../../pages/User/Profile/UpdateProfile"),
);

const AllNotificationsAdmin = lazy(
  () => import("../../pages/Admin/notifications/AllNotifications"),
);
const NotificationDetail = lazy(
  () => import("../../pages/Admin/notifications/NotificationDetails"),
);

const NotFoundPage = lazy(() => import("../../pages/404"));

//common
import AdminDashboard from "../../pages/Admin/AdminDashboard";

export const adminRoutes = [
  {
    path: "/admin",
    element: <AdminRoute element={<AdminDashboard />} />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      { path: "users/:subCat", element: <Users /> },
      { path: "users/:subCat/:id/view", element: <ViewUser /> },

      { path: "assets/:cat", element: <Assets /> },
      { path: "assets/:cat/:id/view", element: <ViewAsset /> },

      { path: "orders/:cat", element: <Orders /> },
      { path: "orders/:cat/:id/view", element: <ViewOrder /> },

      { path: "transactions/:cat", element: <Transactions /> },

      { path: "wallet", element: <Wallet /> },

      { path: "blog/posts", element: <AllPosts /> },
      { path: "blog/posts/new", element: <NewPost /> },
      { path: "blog/posts/:id/update", element: <UpdatePost /> },
      { path: "blog/posts/:id/view", element: <ViewPost /> },

      { path: "platforms", element: <AllPlatform /> },
      { path: "platforms/new", element: <NewPlatform /> },
      { path: "platforms/:id/update", element: <UpdatePlatform /> },

      { path: "categories", element: <AllCategories /> },
      { path: "categories/new", element: <NewCategory /> },
      { path: "categories/:id/update", element: <UpdateCategory /> },

      { path: "profile", element: <Profile />, loader: viewProfileLoader },
      {
        path: "profile/:id/update",
        element: <UpdateProfile />,
        loader: updateProfileLoader,
      },

      { path: "notifications", element: <AllNotificationsAdmin /> },
      { path: "notifications/:id", element: <NotificationDetail /> },

      { path: "*", element: <NotFoundPage /> }, // fallback for wrong admin paths
    ],
  },
];
